import Vue from 'vue'
import { mapActions } from 'vuex'

Vue.mixin({
    methods: {
        ...mapActions('notification', ['createNotification']),
        uniqueId(name) {

            return `uid-${this._uid}-${name}`
        },
        showAlert(message, title = '', large = false, onConfirm = null) {
            return this.createNotification({
                type: 'alert',
                color: 'primary',
                ok: onConfirm || null,
                title,
                message,
                large
            })
        },
        showSaveNotification(message, onConfirm) {
            return this.createNotification({
                type: 'alert',
                color: 'success',
                title: 'Sucesso',
                message: message || 'Registro salvo com sucesso!',
                ok: onConfirm || null
            })
        },
        showDeleteConfirmation(message, onConfirm, onError) {
            return this.createNotification({
                type: 'dialog',
                color: 'danger',
                title: 'Confirmação de exclusão',
                message: message || 'Deseja realmente excluir o item selecionado?',
                confirm: onConfirm,
                onError,
            })
        },
        showCancelConfirmation(message, onConfirm, onError) {
            return this.createNotification({
                type: 'dialog',
                color: 'danger',
                title: 'Confirmação de cancelamento',
                message: message || 'Deseja realmente cancelar o item selecionado?',
                confirm: onConfirm,
                onError,
            })
        },
        showAttentionConfirmation(message, onConfirm, onError) {
            return this.createNotification({
                type: 'dialog',
                color: 'primary',
                title: 'Atenção',
                message: message,
                confirm: onConfirm,
                onError,
            })
        },
        showConfirmation(message, callback, cancelCallback, onError) {
            return this.createNotification({
                type: 'dialog',
                color: 'primary',
                title: 'Confirmação',
                message: message,
                confirm: callback,
                cancel: cancelCallback || null,
                onError,
            })
        },
        showValidationNotification(message) {
            return this.createNotification({
                type: 'alert',
                color: 'danger',
                title: 'Erro',
                message
            })
        },
        showExitConfirmation(onConfirm, onError) {
            return this.createNotification({
                type: 'dialog',
                color: 'danger',
                title: 'Atenção',
                message: 'As informações não salvas serão perdidas. Deseja realmente sair?',
                confirm: onConfirm,
                onError,
            })
        },
        showWarningNotification(message, onConfirm = null) {
            return this.createNotification({
                type: 'alert',
                color: 'warning',
                title: 'Atenção',
                message: message,
                ok: onConfirm || null
            })
        },
        showWarningConfirmation(title, message, onConfirm, onCancel, onError) {
            return this.createNotification({
                type: 'dialog',
                color: 'warning',
                title,
                message,
                confirm: onConfirm || null,
                cancel: onCancel || null,
                onError: onError || null,
            })
        },
        showContinue(message, continuarCallback, aguardarCallback, btnCancel, btnOk, onError ) {
            return this.createNotification({
                type: 'dialog',
                color: 'primary',
                title: 'Confirmação',
                message: message,
                confirm: continuarCallback,
                cancel: aguardarCallback,
                btnCancel: btnCancel,
                btnOk: btnOk,
                onError,
            })
        }
    }
})